import React from 'react';
import { Row, Col, FormGroup, Button, Glyphicon } from 'react-bootstrap';
import { Label } from 'fw/components';
import { Form, TextBox, UrlBox, EmailBox, Switch } from 'fw/forms';
import { Address, PhoneBox } from 'areas/shared/controls';
import * as CompanyInfoTabHelpers from 'areas/shared/helpers/CompanyInfoTabHelpers';

// NVBDC-1404 — "Is the following information correct?" pattern (plan item 14). Switch-driven;
// No reveals the underlying CI fields inline for direct editing (not a popup), reusing the same
// field set the classic wizard's Company Info step already collects.
class CompanySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { correct: true };
    }

    onToggleCorrect = (value) => {
        this.setState({ correct: value });
    };

    onChange = (form) => {
        this.props.onChange(form);
    };

    // Phones is an array field, not a single named value, so it isn't a Form-managed control like
    // vobName/website/email above — same reason the classic wizard's CompanyInfo.js:170-185 drives
    // it by hand instead of a TextBox. Updates go straight through the same onChange choke point
    // (OneSheetRenewal.onVobInfoChange) the Form above uses, so both stay in sync.
    handleAddPhone = () => {
        const phones = [...(this.props.vobInfo.phones || [])];
        phones.push({
            phoneTypeCode: 'MOBILE',
            number: '',
            extension: '',
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.props.onChange({ ...this.props.vobInfo, phones });
    };

    handleRemovePhone = (i) => {
        const phones = [...(this.props.vobInfo.phones || [])];
        phones.splice(i, 1);

        this.props.onChange({ ...this.props.vobInfo, phones });
    };

    handlePhoneChange = (v, i) => {
        const phones = [...(this.props.vobInfo.phones || [])];
        phones[i] = v;

        this.props.onChange({ ...this.props.vobInfo, phones });
    };

    renderPhoneEditor = () => {
        const phones = this.props.vobInfo.phones || [];

        return (
            <FormGroup>
                <Label htmlFor="phoneNumber" required>Phone Number(s)</Label>
                {phones.map((p, i) => (
                    <div key={p.phoneId} className="form-inline">
                        <PhoneBox
                            value={p}
                            showExtension
                            onChange={(v) => this.handlePhoneChange(v, i)}
                            required={i === 0 ? 'required' : ''}
                        />
                        <Button
                            bsStyle="link"
                            title="Remove Phone"
                            onClick={() => this.handleRemovePhone(i)}>&times;</Button>
                    </div>
                ))}
                {phones.length < 5 &&
                    <Button bsStyle="default" bsSize="xsmall" onClick={this.handleAddPhone}>
                        Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} />
                    </Button>
                }
            </FormGroup>
        );
    };

    render() {
        const vob = this.props.vobInfo;
        if (!vob) return null;

        return (
            <div>
                <Row>
                    <Col md={9}>
                        <Label>Is the following information correct?</Label>
                    </Col>
                    <Col md={3}>
                        <Switch
                            name="companyInfoCorrect"
                            labelLeft="No"
                            labelRight="Yes"
                            bsStyle="success"
                            value={this.state.correct}
                            onChange={this.onToggleCorrect}
                        />
                    </Col>
                </Row>
                {this.state.correct ? (
                    <p>
                        <strong>{vob.vobName}</strong><br />
                        {vob.businessAddress && (
                            <React.Fragment>
                                {vob.businessAddress.street1}<br />
                                {vob.businessAddress.street2 && <React.Fragment>{vob.businessAddress.street2}<br /></React.Fragment>}
                                {vob.businessAddress.city}, {vob.businessAddress.stateCode} {vob.businessAddress.zip}<br />
                            </React.Fragment>
                        )}
                        {vob.phones && vob.phones.length > 0 && CompanyInfoTabHelpers.renderPhones(vob.phones)}
                        {vob.website && <React.Fragment>{vob.website}<br /></React.Fragment>}
                        {vob.email}
                    </p>
                ) : (
                    <Form onChange={this.onChange} values={vob} ref={(form) => { this._form = form; }}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="vobName" required>Company Name</Label>
                                    <TextBox name="vobName" placeholder="Company Name" maxLength={100} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="website">Website</Label>
                                    <UrlBox name="website" placeholder="Website" maxLength={100} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label htmlFor="email" required>Email</Label>
                                    <EmailBox required name="email" placeholder="Email" maxLength={100} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                {this.renderPhoneEditor()}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label htmlFor="businessAddress" required>Business Address</Label>
                                    <Address name="businessAddress" required />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                )}
            </div>
        );
    }
}

export default CompanySection;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/sections/CompanySection.js